<template>
  <div class="donate-pre-form wwf-form row small-collapse medium-uncollapse" v-if="this.productIds.length >= 1" v-bind:class="{ 'dark': isDark, 'light': !isDark }">
    <div>
      <div class="small-12 columns first-column" v-if="this.productIds.length > 1">
        <div class="row small-collapse">
          <ul class="type-tab wwf-radio-bttns">
            <li v-for="productdetail in productidsdetail">
              <label class="wwf-controls radio" :for="'product-' +productdetail.productname">{{productdetail.productname}}
                <input type="radio" v-model="product" name="product" :value="productdetail" :id="'product-' +productdetail.productname" v-validate="'required'" />
                <div class="control__indicator"></div>
              </label>
            </li>
          </ul>
          <span class="alert-box" v-show="errors.has('product')">{{errors.first('product')}}</span>
        </div>
      </div>
      <div v-if="!emailprefill" class="small-12 medium-8 medium-centered columns">
        <input name="email" type="text" v-model="email" placeholder="Email">
      </div>
      <div class="small-12 columns dollar-handles">
        <div v-if="product">
          <label v-for="(dollarhandle, index) in product.dollarhandles[product.donationtypes[0]]" class="wwf-controls radio" for="handle0">
            <span v-bind:class="{ selected: dollarhandle.amount ===  handle }" >${{(dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0,-3) : dollarhandle.amount}}</span>
            <input  v-if="!dollarhandleclick" type="radio" v-model="handle" :name="'handle'+index" :value="dollarhandle.amount" :id="'handle'+index" />
            <input v-if="dollarhandleclick" type="radio" v-model="handle" :name="'handle'+index" v-on:click="donateclick(dollarhandle.amount)" :value="dollarhandle.amount" :id="'handle'+index" />
            <div class="control__indicator"></div>
          </label>
          <label class="wwf-controls radio" for="handle4">
            <i v-bind:class="{ selected: handle === 'custom' }" class="fas fa-pencil-alt"></i>
            <input v-if="!dollarhandleclick" type="radio" v-model="handle" name="handle" value="custom" id="handle4" />
            <input v-if="dollarhandleclick" type="radio" v-model="handle" name="handle" v-on:click="donateclick('custom')" value="custom" id="handle4" />
            <div class="control__indicator"></div>
          </label>
        </div>
      </div>
      <div class="small-12 columns" v-if="!this.dollarhandleclick">
        <a href="#/" v-on:click="donate" class="bttn-lrg-arrw">Donate</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'donateRgForm',
  props: {
    productIds: {
      // Attribute for the productID
      type: Array,
      required: true
    },
    emailprefill: {
      type: String,
      required: false,
      default: ''
    },
    currentpage: {
      type: Boolean,
      required: false,
      default: false
    },
    dollarhandleclick: {
      type: Boolean,
      required: false,
      default: false
    },
    isDark: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      email: '',
      handle: '',
      productidsdetail:null,
      product: null,
    }
  },
  created: function() {
    // Get product data (+ packages details)
    this.$store.dispatch("getProductByIds", this.productIds).then(
      response => {
        console.log("getProductByIds", response);
        this.productidsdetail = response;
        this.product = this.productidsdetail[0]
      },
      error => {
        console.error("getProductByIds error", error);
      }
    );
  },
  methods: {
    donateclick: function(dollar) {
      this.handle = dollar;
      this.donate();
    },
    donate: function () {
      this.$validator.validateAll().then(result => {

        if (result) {
          if (window.dataLayer != undefined) { window.dataLayer.push({ 'formName': 'donation', 'event': 'formSubmitSuccessEvent' }); }

          window.open(wwfconfigs.DONATEURL + this.product.urlPath + '?t='+this.product.appealcodesetting.appealid+'&f='+this.product.appealcodesetting.fundid+'&q='+window.btoa('email='+(this.emailprefill!='' ? this.emailprefill : this.email)+'&dollarhandle='+this.handle+'&amount='+(this.handle=='custom' ? '' : this.handle)),(this.currentpage ? "_self" : "_blank" ))

          return;
        }
        else {
          if (window.dataLayer != undefined) { window.dataLayer.push({ 'formName': 'donation', 'event': 'formSubmitEvent' }); }
        }
      });
    }
  }
}
</script>

<style scoped>
.first-column {
  text-align: right;
}

.donate-pre-form * {
  -webkit-transition: all 300ms cubic-bezier(0.770, 0.000, 0.175, 1.000);
  -o-transition: all 300ms cubic-bezier(0.770, 0.000, 0.175, 1.000);
  transition: all 300ms cubic-bezier(0.770, 0.000, 0.175, 1.000);
}

.donate-pre-form {
  padding-top: 1em;
  padding-bottom: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
  position: relative;
}
.donate-pre-form:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 50%;
  height: 1px;
  background-color: var(--wwfTransparentWhite020);
}

ul.dollar-handles {
  margin: 0;
  font-size: 0;
  padding: 15px 0;
}

ul.dollar-handles li {
  display: inline-block;
  margin: 0px 15px 15px 0px;
}

ul.dollar-handles li a {
  display: inline-block;
  background-color: var(--wwfOrange);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 32px;
  font-family: 'WWF';
  padding: 15px 0;
}

.wwf-form .type-tab label.radio {
  color: var(--wwfBlack);
}
.wwf-form.dark .type-tab label.radio {
  color: var(--wwfWhite);
}

.wwf-form .type-tab .wwf-controls.radio input:checked ~ .control__indicator:after {
  background-color: var(--wwfWhite);
}
.wwf-form .dollar-handle .wwf-controls.radio input:checked ~ .control__indicator:after {
  background-color: var(--wwfWhite);
}
.wwf-form .wwf-controls.radio input:checked ~ .control__indicator:after {
  background-color: var(--wwfWhite);
}

.wwf-form.dark .type-tab .wwf-controls.radio input:checked ~ .control__indicator:after {
  background-color: var(--wwfOrange);
}
.wwf-form.dark .dollar-handle .wwf-controls.radio input:checked ~ .control__indicator:after {
  background-color: var(--wwfOrange);
}
.wwf-form.dark .wwf-controls.radio input:checked ~ .control__indicator:after {
  background-color: var(--wwfOrange);
}

.wwf-form .wwf-controls.radio span.selected,
.wwf-form .wwf-controls.radio i.selected {
  color: var(--wwfDarkOrange);
}

.wwf-form.dark .wwf-controls.radio span.selected,
.wwf-form.dark .wwf-controls.radio i.selected {
  color: var(--wwfWhite);
}

</style>



// WEBPACK FOOTER //
// DonateRgForm.vue?a1b33df4